// 中文 — 中国大陆
export default {
  translation: {
    app_name: 'Agora',
    tagline: '让兴趣连接社区',
    nav_explore: '探索',
    nav_find_folks: '找朋友',
    nav_sign_in: '登录',
    nav_join_free: '免费加入',
    nav_sign_out: '退出',
    nav_my_profile: '我的主页',
    nav_notifications: '通知',
    auth_register: '创建账号',
    auth_login: '登录',
    auth_name: '全名',
    auth_email: '电子邮箱',
    auth_password: '密码',
    auth_age: '您的年龄',
    auth_city: '城市',
    auth_building: '小区 / 楼栋',
    auth_country: '国家',
    auth_currency: '货币',
    auth_locale: '语言和地区',
    auth_already_have_account: '已有账号？',
    auth_no_account: '还没有账号？',
    postcode_label: '邮政编码',
    postcode_placeholder: '如 200001',
    profile_edit: '编辑资料',
    profile_bio: '个人简介',
    profile_interests: '兴趣爱好',
    profile_location: '位置',
    profile_theme: '显示主题',
    profile_currency_settings: '货币和地区',
    profile_save: '保存更改',
    profile_cancel: '取消',
    group_join: '加入群组',
    group_leave: '退出群组',
    group_members: '成员',
    group_chat: '聊天',
    group_events: '活动',
    group_shop: '商店',
    group_campaigns: '活动',
    group_about: '关于',
    group_full: '已满',
    group_open: '开放',
    tip_send: '发送打赏',
    tip_amount: '金额',
    tip_message: '留言（可选）',
    wallet_coins: '金币',
    wallet_balance: '余额',
    tips_earned: '已获得',
    event_register: '报名',
    event_unregister: '取消报名',
    event_ticket_price: '门票',
    event_free: '免费',
    event_capacity: '名额',
    event_registered: '已报名',
    no_results: '未找到结果',
    loading: '加载中…',
    error_generic: '出现错误，请稍后再试。',
  }
};
